/* eslint-disable react-hooks/rules-of-hooks */
import { ColumnDef } from '@tanstack/table-core';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import React, { useState } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { alphanumericSort } from 'src/pages/analytics/simulator/innovation/utils/utils';
import { handleGlobalDropdownValueInputChange, handleGlobalDropdown2ValueInputChange } from '../store/table-slice';
import SelectInputBox from '../../../../pricing-simulator/components/table-columns/select-input-box';
import {
  Header,
  TableComponent,
  InputType
} from '../../../../pricing-simulator/types/generic-table.model';

export default function getColumnForDropdownType(
  columnData: Header,
  columnMetadata: Header[],
  componentType?: TableComponent,
  maxVal?: number,
  inputsDisabled?: boolean
) {
  let sortedDropdownData = [...columnData.parent.static_values];  
  // checking for implement period dropdown by key and string
  if (
    columnData.parent.alias === 'Implement Period' ||
    columnData.parent.alias.toLowerCase().includes('implement') ||
    columnData.parent.alias.toLowerCase().includes('period')
  ) {
    // sorting by value
    sortedDropdownData = sortedDropdownData.sort((a, b) =>
      a.value > b.value ? 1 : -1
    );
  }
  const subHeader: ColumnDef<{ [key: string]: number | string }> = {
    accessorKey: columnData.parent.parent_field,
    header: (props) => {
      const appDispatch = useAppDispatch();
      const { pricingAction1Value } = useAppSelector((state) => state.table);
      const [value, setValue] = useState<any>(pricingAction1Value);
      const handleValueChange: any = (e) => {
        setValue(e.target.value);
        appDispatch(
          handleGlobalDropdownValueInputChange({
            columnMetadata: columnData,
            newValue: e.target.value
          })
        );
      };
      return (
        <div>
          {columnData.parent.is_global_input_enable === true && (
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <Select
                value={value}
                onChange={handleValueChange}
                displayEmpty
                disabled={inputsDisabled}
                inputProps={{ 'aria-label': 'Without label' }}
                style={{
                  width: '120px',
                  height: '30px',
                  border: '1px solid transparent',
                  textAlign: 'left',
                  fontSize: '12px'
                }}
              >
                {columnData.parent.static_values &&
                  columnData.parent.static_values.length > 0 &&
                  alphanumericSort(sortedDropdownData).map((option, i) => (
                    // eslint-disable arrow-body-style
                    <MenuItem
                      key={i}
                      value={option.value}
                      style={{ fontSize: '12px' }}
                    >
                      {option.alias}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}
        </div>
      );
    },
    cell: ({ cell, row }) => {
      const idColumns: Header[] = columnMetadata
        .filter(
          (data) =>
            !data.parent.is_visible &&
            data.parent.field_format === InputType.NUMBER
        )
        .sort((a, b) => a.parent.level - b.parent.level);
      return (
        <SelectInputBox
          row={row}
          uniqueIDColumns={idColumns}
          inputsDisabled={inputsDisabled}
          columnMetadata={columnData}
        />
      );
    },
    meta: {
      className:
        columnData.parent.order === maxVal || maxVal === undefined
          ? 'last'
          : '',
      style: { minWidth: '125px', textAlign: 'center' }
    }
  };
  return subHeader;
}
